import { createApp } from 'vue';
import router from './router';
import App from './App.vue';
import directives from './directives';

// Import our custom CSS
import './scss/main.scss';
import './assets/styles/fonts.sass';

// Pinia state
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

import * as Sentry from '@sentry/vue';
import { PostHogUtils } from './core/PostHogUtils';
import { MarketingSource } from './core/marketingSource';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);

Sentry.init({
  app,
  dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  environment: import.meta.env.VITE_APP_ENV,
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration({ router })],

  tracesSampleRate: 0.15,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  // tracePropagationTargets: ["localhost", /^https:\/\/api.4casters\.io/],
});

PostHogUtils.init();

// Snapshot first-touch marketing attribution from the landing URL before any
// navigation rewrites it. Stored locally; attached to the signup events later.
MarketingSource.captureOnLoad();

app.use(pinia).use(router).use(directives).mount('#app');
